export default {
  color: {
    primary: "#009de0",
    onPrimary: "#ffffff",
    surface: "#1a1b25",
    onSurface: "#ffffff",
    border: "rgba(255, 255, 255, 0.1)"
  },
  font: {
    family: '"Nunito", sans-serif',
    light: 300,
    normal: 400,
    semibold: 600,
    bold: 700,
    size: "18px",
    xsmall: ".8em",
    small: ".9em",
    base: "1em",
    medium: "1.5em",
    large: "2em",
    xlarge: "2.5em",
    lineHeight: "1.2em",
    menu: "1.2em"
  },
  options: {
    outline: false,
    animate: false,
    shadow: false,
    scale: true,
    menu: "vertical"
  }
}
